import * as React from "react";

import { cn } from "@/lib/utils";

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          // Base
          "flex h-12 w-full rounded-lg border border-sds-neutral-20 bg-white px-4 text-base md:text-sm placeholder:text-muted-foreground file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground",
          // Interaction
          "focus-visible:outline-none focus-visible:ring-0 focus-visible:border-sds-purple-100",
          // Hover/disabled
          "hover:border-sds-neutral-40 disabled:cursor-not-allowed disabled:bg-sds-neutral-00 disabled:text-sds-neutral-60",
          // Invalid state (from FormControl aria-invalid)
          "aria-[invalid=true]:border-destructive aria-[invalid=true]:text-destructive",
          className
        )}
        ref={ref}
        {...props}
      />
    );
  }
);
Input.displayName = "Input";

export { Input };
